import React, { FC } from 'react';
import { Grommet, GrommetExtendedProps } from 'grommet';

const GrommetComponent: FC<GrommetExtendedProps> = ({ children, ...props }) => {
  return <Grommet {...props}>{children}</Grommet>;
};

export default GrommetComponent;
